import type { State as S, Selector } from 'model/State';

export const selectHasSourceDownloads: Selector<object> = (state: S) =>
  state.mac.downloads.hasSourceDownloads || {};

export const selectProductSourceDownloads: Selector<object> = (state: S) =>
  state.mac.downloads.productSourceDownload || {};

export const selectSourceDownloadURL: Selector<object> = (state: S) =>
  state.mac.downloads.sourceDownloadURL || {};
